import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import './style.scss';

import imgBlue1 from '../../../../assets/t-104/blue1-small.png';
import imgBlue1big from '../../../../assets/t-104/blue1-big.png';
import imgBlue2 from '../../../../assets/t-104/blue2-small.png';
import imgBlue2big from '../../../../assets/t-104/blue2-big.png';
import imgBlue3 from '../../../../assets/t-104/blue3-small.png';
import imgBlue3big from '../../../../assets/t-104/blue3-big.png';

import imgGreen1 from '../../../../assets/t-104/green1-small.png';
import imgGreen1big from '../../../../assets/t-104/green1-big.png';
import imgGreen2 from '../../../../assets/t-104/green2-small.png';
import imgGreen2big from '../../../../assets/t-104/green2-big.png';
import imgGreen3 from '../../../../assets/t-104/green3-small.png';
import imgGreen3big from '../../../../assets/t-104/green3-big.png';

import imgOrange1 from '../../../../assets/t-104/orange1-small.png';
import imgOrange1big from '../../../../assets/t-104/orange1-big.png';
import imgOrange2 from '../../../../assets/t-104/orange2-small.png';
import imgOrange2big from '../../../../assets/t-104/orange2-big.png';
import imgOrange3 from '../../../../assets/t-104/orange3-small.png';
import imgOrange3big from '../../../../assets/t-104/orange3-big.png';

import imgPink1 from '../../../../assets/t-104/roz1-small.png';
import imgPink1big from '../../../../assets/t-104/roz1-big.png';
import imgPink2 from '../../../../assets/t-104/roz2-small.png';
import imgPink2big from '../../../../assets/t-104/roz2-big.png';
import imgPink3 from '../../../../assets/t-104/roz3-small.png';
import imgPink3big from '../../../../assets/t-104/roz3-big.png';
import DownloadButton from '../../../download-button';

const DATA = [
    [imgBlue1, imgBlue1big],
    [imgBlue2, imgBlue2big],
    [imgBlue3, imgBlue3big],
    [imgGreen1, imgGreen1big],
    [imgGreen2, imgGreen2big],
    [imgGreen3, imgGreen3big],
    [imgOrange1, imgOrange1big],
    [imgOrange2, imgOrange2big],
    [imgOrange3, imgOrange3big],
    [imgPink1, imgPink1big],
    [imgPink2, imgPink2big],
    [imgPink3, imgPink3big],
]

type Props = {
    onComplete?: () => void
}

const Task104: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    useEffect(() => {
        onComplete();
    }, [onComplete])

    const { task } = useTask('t-104');

    return <div className="task task-104">
        <h2>zadanie 4</h2>
        <h3>{task?.title}</h3>
        <p>
            Co dla Was oznacza hasło „Czytanie wzmacnia"?
        </p>
        <p className="instruction">
            Zadanie: Wybierzcie spośród poniższych te elementy wzmacniane przez czytanie, które są Wam najbliższe. A może macie własne pomysły? Pobierzcie te zakładki do książek, których będziecie używać, ciesząc się z mocy czytania!
        </p>
        <div className="images">
            {DATA.map((img, index) => {
                return <div key={index} className="image">
                    <img src={img[0]} alt="zakładka" />
                    <DownloadButton src={img[1]} file={`zakladka_${index}.png`} />
                </div>
            })}
        </div>
    </div>
}

export default Task104;
